<template>

    <router-link class="case-study" :key="study.id" :to="study.slug">
        <!-- <div class="image-parallax"> -->
        <div class="case-study__image">
            <SafeImage 
                :imageData="study.FeaturedImage"
                :src="study.url" 
                :alt="study.alternativeText || study.title"
                :placeholder="PLACEHOLDER_IMAGES.CASE_STUDY"
                placeholderText="Case study image not available"
                imageClass="case-study-image"
                :debug="true"
            />
        </div>

        <h3> {{ study.title }} </h3>

        <p> {{ study.caption }} </p>

    </router-link>

</template>

<script lang="ts">

import { defineComponent, PropType } from 'vue'
import SafeImage from '../../components/SafeImage.vue'
import { PLACEHOLDER_IMAGES } from '../../composables/useImageErrorHandler'

export default defineComponent({
    components: {
        SafeImage
    },
    props: {
        study: {
            type: Object as PropType<{ title: string, caption: string, url: string, slug: string, alternativeText: string, id: number, FeaturedImage: { data: { attributes: { url: string, alternativeText: string, formats: any } } } }>,
            required: true
        }
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL
        const { title, caption, url, slug, alternativeText, id, FeaturedImage } = props.study;
        
        return { 
            title, 
            caption, 
            homeurl, 
            url, 
            slug, 
            alternativeText, 
            id,
            FeaturedImage,
            PLACEHOLDER_IMAGES
        }
    }
})
</script>

<style scoped>
.case-study-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
